export default __webpack_public_path__ + "static/media/YALWA.d0e66250.png";